import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';

import ModalDynamic from '../../modal/Dynamic/Dynamic';

import {Container, Row, ListGroup} from 'react-bootstrap';

import {ReactComponent as ImgBag} from '../../../asset/img/icon/bag.svg';
import {ReactComponent as ImgAward} from '../../../asset/img/icon/award.svg';
import {ReactComponent as ImgGiftCard} from '../../../asset/img/icon/gift-card.svg';
import {ReactComponent as ImgCustomerClub} from '../../../asset/img/icon/customer-club.svg';

// import * as IconFi from 'react-icons/fi';
import * as IconTb from 'react-icons/tb';

import './Explore.scss';

const Explore = () => {
    const auth = useContext(ContextAuth);

    // -----------------------------------------------------------------------------------------------------------------

    const data = [
        {id: 1, title: 'تخفیف ها', to: '/offers', icon: <IconTb.TbDiscount2 size={24} className="sw-1"/>},
        {id: 2, title: 'باشگاه مشتریان', to: '/customer-club', icon: <ImgCustomerClub className="sw-1"/>},
        // {id: 3, title: 'خرید', to: '/shopping', icon: <ImgBag className="sw-1"/>},
        {id: 3, title: 'خرید', to: '/shop', icon: <ImgBag className="sw-1"/>},
        {id: 4, title: 'همراه متخصص', to: '/services/expert-companion', icon: <ImgAward className="sw-1"/>},
        {id: 5, title: 'کارت هدیه', to: '/services/gift-card', icon: <ImgGiftCard className="sw-1"/>}
    ]

    // --------------------------------------------------------------------------------------------------- dynamic modal

    const [modalDynamicShow, setModalDynamicShow] = useState(false);
    const [modalData, setModalData] = useState(null);

    const modalDynamicShowHandler = item => {

        setModalData(() => {
            return {'title': item.title, 'url': item.file}
        })

        setModalDynamicShow(true);
    };

    // -----------------------------------------------------------------------------------------------------------------

    const renderItem = item => {
        return (
            <ListGroup.Item action {... !item.to ? {type: 'button'} : {}} as={item.to && Link} to={item.to && item.to} className={`col bg-transparent d-flex flex-column align-items-center border-0 text-center text-reset${!item.to ? ' w-auto' : ''}`} onClick={() => !item.to && modalDynamicShowHandler(item)} key={item.id}>
                <span className="bg-primary p-2 mb-2 rounded-square">{item.icon}</span>
                <span className="fw-normal lh-sm fs-8">{item.title}</span>
            </ListGroup.Item>
        )
    }

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            <Container fluid="lg" as="section" id="explore" className={auth?.user ? 'mt-4 pt-3' : 'mt-3'}>
                <Row>
                    <h2 className="fs-5 fw-normal mb-2">کاوش</h2>
                    <div className="overflow-auto px-0 d-flex hide-scrollbar">
                        <ListGroup horizontal>
                            {
                                data.map(item => {
                                    return (
                                        renderItem(item)
                                    )
                                })
                            }
                        </ListGroup>
                    </div>
                </Row>
            </Container>
            <ModalDynamic show={modalDynamicShow} onHide={() => setModalDynamicShow(false)} data={modalData}/>
        </>
    )
}

export default Explore;